import React from "react";
import PropTypes from "prop-types";
import { withRouter } from "react-router";
import RelativeLink from "../common/RelativeLink";
import { connect } from "react-redux";

// Eigenlijk FinancieelSwitcher
const SideNavFinancieel = ({ items, routePrefix }) => {
	return (<aside className={"c-reactsidenav"}>
		{items.map((item, i) => {
			return (<p className="center" key={"sidenav_" + i}>
				<span className="sidenav-title">{item.titel}</span>
				<br />
				{item.items.map((itemFinancieel, i) => {
					return <RelativeLink key={i} className="c-reactsidenav__item truncated" to={routePrefix + "/" + itemFinancieel.urlSuffix}>{itemFinancieel.titel}</RelativeLink>;
				})}
			</p>);
		})}
	</aside>);
};

SideNavFinancieel.propTypes = {
	items: PropTypes.array,
	routePrefix: PropTypes.string
};

function mapStateToProps(state, ownProps) {
	return {
		items: state.layout.sideNavItems,
		routePrefix: state.layout.sideNavPrefix
	};
}

export default connect(mapStateToProps)(withRouter(SideNavFinancieel));
